import { render, staticRenderFns } from "./MoveTarget.vue?vue&type=template&id=34dff072&"
import script from "./MoveTarget.vue?vue&type=script&lang=js&"
export * from "./MoveTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports